/* eslint-disable no-undef */
class SpyTools {
  constructor() {
    this.debuggerHost = 'https://pgspy.chinathinksbig.com';
    this.jsList = [
      `${this.debuggerHost}/page-spy/index.min.js`,
      `${this.debuggerHost}/plugin/data-harbor/index.min.js`,
      `${this.debuggerHost}/plugin/rrweb/index.min.js`
    ];
    this.initial();
    this.isOpenSite = /^localhost|test|gray/.test(window.location.host);
    this.isPosterPath = /poster/i.test(window.location.pathname);
    if (
      !this.isPosterPath &&
      (localStorage.getItem('PAGE_SPY_OPEN') === 'true' || this.isOpenSite)
    ) {
      console.log('page spy is opened');
      this.start();
    } else {
      console.log('page spy is closed');
    }
  }
  getRequest = decode => {
    let ifDecode = true;
    if (decode === false) {
      ifDecode = false;
    }
    let url = location.search;
    let theRequest = {};
    if (url && url.length && url.indexOf('?') > -1) {
      let str = url.substr(1);
      let strs = str.split('&');
      for (let i = 0; i < strs.length; i++) {
        if (ifDecode) {
          theRequest[strs[i].split('=')[0]] = decodeURI(strs[i].split('=')[1]);
        } else {
          theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1];
        }
      }
    }
    return theRequest;
  };
  start() {
    this.setScript(this.jsList, { timeout: 5000 }).then(() => {
      window.$harbor = new DataHarborPlugin();
      window.$rrweb = new RRWebPlugin();

      [window.$harbor, window.$rrweb].forEach(p => {
        PageSpy.registerPlugin(p);
      });

      window.$pageSpy = new PageSpy();
    });
  }
  initial() {
    const pageSpyUrlData = this.getRequest()?.['page-spy'];
    const openReg = /open|true|1/;
    const closeReg = /close|false|0/;
    if (openReg.test(pageSpyUrlData)) {
      localStorage.setItem('PAGE_SPY_OPEN', true);
    } else if (closeReg.test(pageSpyUrlData)) {
      localStorage.removeItem('PAGE_SPY_OPEN');
    }
  }
  /**
   * 动态加载多个JavaScript文件
   * @param {string[]} scriptSources - 需要加载的JS文件路径数组
   * @param {Object} [options] - 可选配置
   * @param {number} [options.timeout=5000] - 每个脚本的加载超时时间
   * @returns {Promise<void>}
   */
  setScript(scriptSources, options = {}) {
    // 处理参数
    const sources = Array.isArray(scriptSources) ? scriptSources : [scriptSources];
    const timeout = options.timeout || 5000;

    // 返回Promise
    return new Promise((resolve, reject) => {
      // 如果没有脚本需要加载，直接resolve
      if (sources.length === 0) {
        resolve();
        return;
      }

      // 跟踪加载状态
      const loadedScripts = new Set();
      const errorScripts = new Set();

      // 创建脚本加载函数
      function loadScript(src) {
        return new Promise((scriptResolve, scriptReject) => {
          // 检查是否已经加载过此脚本
          if (document.querySelector(`script[src="${src}"]`)) {
            loadedScripts.add(src);
            scriptResolve();
            return;
          }

          // 创建script元素
          const script = document.createElement('script');
          script.src = src;
          script.async = true;

          // 成功回调
          script.onload = () => {
            loadedScripts.add(src);
            scriptResolve();
          };

          // 错误回调
          script.onerror = () => {
            errorScripts.add(src);
            scriptReject(new Error(`Failed to load script: ${src}`));
          };

          // 超时处理
          const timeoutId = setTimeout(() => {
            errorScripts.add(src);
            scriptReject(new Error(`Timeout loading script: ${src}`));
          }, timeout);

          // 清理定时器
          script.onload = () => {
            clearTimeout(timeoutId);
            loadedScripts.add(src);
            scriptResolve();
          };

          script.onerror = () => {
            clearTimeout(timeoutId);
            errorScripts.add(src);
            scriptReject(new Error(`Failed to load script: ${src}`));
          };

          // 添加到文档
          document.head.appendChild(script);
        });
      }

      // 并行加载所有脚本
      Promise.allSettled(sources.map(loadScript)).then(results => {
        // 检查是否有加载失败的脚本
        const failedScripts = results.filter(result => result.status === 'rejected').map((result, index) => sources[index]);

        if (failedScripts.length > 0) {
          // 部分脚本加载失败
          const error = new Error('Some scripts failed to load');
          error.failedScripts = failedScripts;
          error.loadedScripts = Array.from(loadedScripts);
          reject(error);
        } else {
          // 全部脚本加载成功
          resolve();
        }
      });
    });
  }
}
export default new SpyTools();
